import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	teamManagedIllustrationFooter: {
		id: 'project-create-importer-upload-flow.project-create-screen.illustration.team-managed-illustration-footer',
		defaultMessage: 'Team-managed project',
		description:
			'Message in the footer navigation bar for the illustration, indicating that the user is in a team-managed project',
	},
	companyManagedIllustrationFooter: {
		id: 'project-create-importer-upload-flow.project-create-screen.illustration.company-managed-illustration-footer',
		defaultMessage: 'Company-managed project',
		description:
			'Message in the footer navigation bar for the illustration, indicating that the user is in a company-managed project',
	},
});
